import type { GoalChecklistSnapshot } from './goalChecklist';

export const DEMO_GOAL_CHECKLIST_SNAPSHOT: GoalChecklistSnapshot = {
  goalId: 'demo-goal-setting', revision: 1, title: 'Shape a meaningful goal', status: 'active', activeItemId: 'define-success', completedCount: 2, totalCount: 6, updatedAt: '2026-09-01T00:00:00.000Z', demo: true,
  items: [
    {
      id: 'desired-outcome', label: 'Clarify the desired outcome', status: 'completed', required: true,
      description: 'The learner can say, concretely, what would be different once the goal is reached.',
      masteryCriteria: ['names an observable end state', 'distinguishes the outcome from the activity'],
      attemptCount: 2, confidence: 0.85,
      latestEvidence: {
        text: 'demonstrating: names a concrete end state (5k without stopping by December) and separates it from the activity.',
        source: 'llm_judge', turnId: 'turn_4', createdAt: '2026-09-05T10:04:00.000Z',
        learnerExcerpt: 'I want to be able to run 5k without stopping by December, not just run more.',
      },
    },
    { id: 'why-it-matters', label: 'Understand why it matters', status: 'completed' },
    {
      id: 'define-success', label: 'Define what success looks like', status: 'active', required: true,
      description: 'The learner sets a check they could actually run to know the goal is met.',
      masteryCriteria: ['states a measurable or observable check', 'ties the check to the desired outcome'],
      attemptCount: 1, confidence: 0.4,
    },
    { id: 'surface-constraints', label: 'Surface constraints', status: 'partial' },
    { id: 'first-action', label: 'Choose the first action', status: 'pending' },
    { id: 'follow-up', label: 'Agree on a follow-up', status: 'deferred', optional: true },
  ],
};
